import { useTranslation } from 'react-i18next';

const CreditLocked = () => {
  const { t } = useTranslation();

  return (
    <>
      <p>
        You can unlock your credit by contacting Experian’s Consumer Helpdesk at <a href="tel:1-866-617-1894">1-866-617-1894</a>.
      </p>

      <p>
        We will try to pull your credit again in the next 24 hours. If you need any assistance with this, please contact us at{' '}
        <a href={`tel:${t('phone.customerService')}`}>{t('phone.customerService')}</a>.
      </p>

      <p>This will not affect your credit.</p>
    </>
  );
};

export default CreditLocked;
